import AbstractElement from "../pages/AbstractElement";


class CSSTransitionInElement extends AbstractElement {

    constructor(template: JQuery) {
        super(template);
    }

    update(scrollTop: number = 0, fixRange: number = 0): void {
        const screenCenter = {
            x: window.innerWidth * 0.5,
            y: window.innerHeight * 0.5
        };
        const distance = (this.template.offset().top - scrollTop);
        if (distance <= (screenCenter.y + fixRange)) {
            this.transitionIn();
        }
    }

    init(): void {

    }

    transitionIn(): void {
        this.template.addClass('t-in');
    }

    transitionOut(): void {
        this.template.removeClass('t-in');
    }
}

export default CSSTransitionInElement;